<app-choice-card
  [title]="'Что тебе ближе?'"
  [folder]="'1'"
  [stepsCount]="4"
  [currentStep]="currentStep"
  [options]="[
    questions[currentStep].answers[0].value,
    questions[currentStep].answers[1].value
  ]"
  (optionSelected)="selected(questions[currentStep].answers[$event].score)"
>
</app-choice-card>